import type { GetProjects } from '@/server/api/rest/project';
import type { GetContentTranslations } from '@embira/translations';

type UseTranslatedProjectsProps = {
  projects: GetProjects;
  translations: GetContentTranslations;
};

export const useTranslateProjects = ({
  projects,
  translations,
}: UseTranslatedProjectsProps) => {
  const translatedProjects = projects.map((project: GetProjects[number]) => {
    const projectTranslations = translations.filter(
      (t: GetContentTranslations[number]) => t.foreignKey === project.id
    );

    if (!projectTranslations?.length) {
      return project;
    }

    const translatedFields = Object.fromEntries(
      projectTranslations.map((translation: GetContentTranslations[number]) => [
        translation.field,
        translation.value,
      ])
    );

    return {
      ...project,
      title: translatedFields.title ?? project.title,
      subtitle: translatedFields.subtitle ?? project.subtitle,
      challenge: translatedFields.challenge ?? project.challenge,
      solution: translatedFields.solution ?? project.solution,
      result: translatedFields.result ?? project.result,
    };
  });

  return {
    data: translatedProjects,
    isLoading: false,
    error: null,
  };
};
